/** @format */
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router-dom";
import * as formik from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../../store/hook";
import * as Selector from "../../../../../../store/auth/selector"; // Adjust the path if necessary
import DatePicker from "react-datepicker";
import { useCreateUserExperience } from "../../../../../../api/mutations/user.mutation";
import { useGenerateNewAccessTokenByRefreshToken } from "../../../../../../api/mutations/auth.mutation";
import { setRefreshToken, signInSuccess } from "../../../../../../store";

function ExperienceForm() {
  const { Formik } = formik;
  const refreshToken = useAppSelector(Selector.refresh_token);

  const schema = yup.object().shape({
    company_string: yup.string().required("Please enter the company name"),
    title: yup.string().required("Please enter your designation"),
    start_date: yup.date().required("Please select a start date"),
    end_date: yup.date().nullable(),
    description: yup.string().required("Please enter your responsibility"),
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const refreshTokenMutation = useGenerateNewAccessTokenByRefreshToken({
    onSuccess: (data) => {
      console.log(data);
      const { access_token } = data.data;
      dispatch(signInSuccess(access_token));
    },
    onError: (error) => {
      console.error("Failed to refresh token:", error.message);
    },
  });

  const userExperienceMutation = useCreateUserExperience({
    onSuccess: () => {
      console.log("onSuccess");
      window.location.reload();
      navigate("/u/user_profile#experience");
    },
    onError: (error) => {
      console.error("Failed to create experience:", error.message);
      if (error.message) {
        createNewToken();
      }
    },
    successMessage: "Experience Added Successfully!",
  });

  const onCreate = (data) => {
    userExperienceMutation.mutate({
      start_date: data.start_date,
      end_date: data.end_date,
      description: data.description,
      title: data.title,
      company_id: data.company_id,
      company_string: data.company_string,
    });
  };

  const createNewToken = () => {
    console.log("refresh_token", refreshToken);
    refreshTokenMutation.mutate({
      refresh_token: refreshToken,
    });
  };

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onCreate}
      initialValues={{
        company_id: "27be33bc-4cab-43f9-bbe2-1868500cc27c",
        company_string: "",
        title: "",
        start_date: null,
        end_date: null,
        description: "",
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        values,
        touched,
        errors,
      }) => (
        <Form noValidate onSubmit={handleSubmit} className="mt-5">
          <Row className="mb-2">
            <h3 className="mb-3">Add Working Experience</h3>
            <Form.Group
              as={Col}
              controlId="validationFormikCompany"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Company Name
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Company.Sdn.Bhd"
                name="company_string"
                value={values.company_string}
                onChange={handleChange}
                isInvalid={touched.company_string && !!errors.company_string}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.company_string}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikTitle"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Designation
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="UI UX Designer"
                name="title"
                value={values.title}
                onChange={handleChange}
                isInvalid={touched.title && !!errors.title}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.title}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikStartDate"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Starting Period
              </Form.Label>
              <DatePicker
                selected={values.start_date}
                onChange={(date) => setFieldValue("start_date", date)}
                dateFormat="yyyy/MM/dd"
                className="form-control mb-0"
                placeholderText="Select start date"
              />
              {touched.start_date && errors.start_date && (
                <div className="text-danger">{errors.start_date}</div>
              )}
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikEndDate"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Ending Period
              </Form.Label>
              <DatePicker
                selected={values.end_date}
                onChange={(date) => setFieldValue("end_date", date)}
                dateFormat="yyyy/MM/dd"
                className="form-control mb-0"
                placeholderText="Select end date (optional)"
              />
              {touched.end_date && errors.end_date && (
                <div className="text-danger">{errors.end_date}</div>
              )}
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikDescription"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Responsibility
              </Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Write your responsibility"
                name="description"
                value={values.description}
                onChange={handleChange}
                isInvalid={touched.description && !!errors.description}
                className="form-control mb-0"
                rows={4}
              />
              <Form.Control.Feedback type="invalid">
                {errors.description}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-end">
            <Button
              variant="success"
              type="submit"
              className="btn btn-success mt-4 fw-semibold text-uppercase"
            >
              Add Experience
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default ExperienceForm;
